import ApiClient from '@afosto/api/ApiClient';

class Options {
  constructor(client) {
    this.apiClient = client || ApiClient;
  }

  /**
   * Get required fiels for an address based on country
   *
   * @param {Object} query - The optional path parameters
   * @param {string} [query.countryCode] - Defaults to country that can be linked to client IP
   * @param {Object} options - The additional request options
   * @description List required fields
   * @returns {Promise}
   */
  getRequiredAddressFields(query = {}, options = {}) {
    const params = {
      country_code: query.countryCode,
    };

    return this.apiClient.request({
      url: `/rel/options/addresses`,
      method: 'get',
      params,
      ...options,
    });
  }

  /**
   * Search address
   *
   * @param {Object} body
   * @param {Object} options - The additional request options
   * @description Search an address
   * @returns {Promise}
   */
  searchAddress(body, options = {}) {
    return this.apiClient.request({
      url: `/rel/search/addresses`,
      method: 'post',
      data: body,
      ...options,
    });
  }

  /**
   * Start session
   *
   * @param {Object} query - The optional path parameters
   * @param {string} [query.countryCode]
   * @param {string} [query.sessionKey]
   * @param {Object} options - The additional request options
   * @description Start an search session
   * @returns {Promise}
   */
  startAddressSearchSession(query = {}, options = {}) {
    const params = {
      country_code: query.countryCode,
      session_key: query.sessionKey,
    };

    return this.apiClient.request({
      url: `/rel/search/addresses`,
      method: 'get',
      params,
      ...options,
    });
  }
}

export const options = new Options();

export default Options;
